<template>
  <div class="p-4 bg-white rounded-lg h-100" v-if="isDataLoaded">
    <DataTable
      :table_state="table_state"
      :store_names="store_names"
      :addComponent="componentForAdding"
      :editComponent="componentForEditing"
      :urls="urls"
      @handleTokenModal="handleTokenModal"
    />
    <TokenModal type="Client secret" ref="tokenModal" />
  </div>
</template>

<script>
import DataTable from "@/own/components/DataTable.vue";
import AddItem from "@/own/components/shipping/couriers/AddItem.vue";
import EditItem from "@/own/components/shipping/couriers/EditItem";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
import {
  EXPORT_TABLE_DATA,
  SET_TABLE_FILTER,
  SET_TABLE_PAGE,
  SET_TABLE_PERPAGE,
  SET_TABLE_SORTBY,
  UPDATE_TABLE_DATA,
  UPDATE_TABLE_STRUCTURE,
} from "@/core/services/store/couriers.module";
import TokenModal from "@/own/components/Modals/TokenModal";

export default {
  name: "Couriers",
  components: { DataTable, TokenModal },
  data: () => ({
    componentForEditing: EditItem,
    componentForAdding: AddItem,
    table_state: {
      UPDATE_TABLE_STRUCTURE: UPDATE_TABLE_STRUCTURE,
      UPDATE_TABLE_DATA: UPDATE_TABLE_DATA,
      SET_TABLE_SORTBY: SET_TABLE_SORTBY,
      SET_TABLE_FILTER: SET_TABLE_FILTER,
      SET_TABLE_PERPAGE: SET_TABLE_PERPAGE,
      SET_TABLE_PAGE: SET_TABLE_PAGE,
      EXPORT_TABLE_DATA: EXPORT_TABLE_DATA,
    },
    store_names: {
      getTableFilters: "getCOURIERSTableFilters",
      getTableState: "getCOURIERSTableState",
      getTableData: "getCOURIERSTableData",
      getTableHeaders: "getCOURIERSTableHeaders",
      getTableProperties: "getCOURIERSTableProperties",
      getTableExportUrl: "getCOURIERSExportUrl",
      getTablePermissions: "getCOURIERSTablePermissions",
    },
    urls: {
      delete: `/shipping/couriers/destroy`,
      generateClientToken: "/shipping/couriers/generate_webhook_client_secret",
    },
  }),
  methods: {
    async initTableContent() {
      await this.$store.dispatch(this.table_state.UPDATE_TABLE_STRUCTURE, {});
      await this.$store.dispatch(this.table_state.UPDATE_TABLE_DATA, {});
    },
    handleTokenModal(token) {
      this.$refs.tokenModal.tokenDialog = true;
      this.$refs.tokenModal.tokenData = token;
      this.$store.commit(SET_PAGE_LOADING, false);
    },
  },
  computed: {
    isDataLoaded: function () {
      return this.$store.getters[this.store_names.getTableData];
    },
  },
  beforeMount() {
    this.$store.commit(SET_PAGE_LOADING, true);
    this.initTableContent();
  },
};
</script>
